module.exports = __webpack_public_path__ + "img/revox_hoverd.48b1388a.svg";